(function (window, $) {
  new Rellax(".rellax");
})(window, jQuery);
